/* istanbul ignore file */
import { Handler } from "pagedjs";

/**
 * Utility function to copy canvas (that have a data-ref attribute) content from source to target
 */
const copyCanvasContent = (
  sourceCanvas: HTMLCanvasElement,
  targetCanvas: HTMLCanvasElement
): void => {
  try {
    // Check if source canvas has valid dimensions
    if (sourceCanvas.width <= 0 || sourceCanvas.height <= 0) {
      return;
    }

    // Get the context of the target canvas
    const targetContext = targetCanvas.getContext("2d");
    if (!targetContext) {
      return;
    }

    // Set dimensions of target canvas to match source
    targetCanvas.width = sourceCanvas.width;
    targetCanvas.height = sourceCanvas.height;

    // Copy the content from source to target
    targetContext.drawImage(sourceCanvas, 0, 0);
  } catch (error) {}
};

// This handler is used to fix the canvas content in the preview
export class FixCanvasHandler extends Handler {
  private lastOriginalCanvasIndex = 0;

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(chunker: any, polisher: any, caller: any) {
    super(chunker, polisher, caller);
  }

  beforeParsed(content: HTMLElement): void {
    // console.log("beforeParsed");
  }

  afterParsed(parsed: HTMLElement): void {
    // console.log("afterParsed");
  }

  afterPageLayout(pageFragment: any, page: any): void {
    // Get all canvases from the original content
    const originalCanvases: HTMLCanvasElement[] = Array.from(
      document.querySelectorAll("canvas")
    ).filter((canvas) => {
      // Filter out canvases that are already in the preview
      const closestPreview = canvas.closest("#preview");
      return !closestPreview;
    });

    // Get all canvases in the current page fragment
    const previewCanvases: HTMLCanvasElement[] = Array.from(
      page.element.querySelectorAll("canvas")
    );

    // If there are no canvases to process, exit early
    if (originalCanvases.length === 0 || previewCanvases.length === 0) {
      return;
    }

    // Try to match canvases based on relative position and properties
    previewCanvases.forEach((previewCanvas: HTMLCanvasElement) => {
      // Try to find a matching original canvas
      let matchedOriginalCanvas: HTMLCanvasElement | null = null;

      // match by position/index
      if (this.lastOriginalCanvasIndex < originalCanvases.length) {
        // Simple positional matching - use the same index
        matchedOriginalCanvas = originalCanvases[this.lastOriginalCanvasIndex];
      }

      // If we found a matching canvas, copy its content
      if (matchedOriginalCanvas) {
        copyCanvasContent(matchedOriginalCanvas, previewCanvas);
        this.lastOriginalCanvasIndex++;
      }
    });
  }
}
